import React, { ReactNode } from 'react';
import { Tooltip } from 'antd';
import { t } from 'i18next';

import { Maybe } from 'shared/types';
import { Avatar } from 'shared/ui/Avatar';

import styles from '../DemandWidget.module.scss';
import { DataType } from '../DemandWidget.types';

const TooltipAvatar = React.forwardRef<
  HTMLDivElement,
  {
    picture: Maybe<string>;
    text: string;
  }
>(({ picture, text, ...props }, ref) => (
  /* eslint-disable react/jsx-props-no-spreading */
  <div {...props} ref={ref}>
    <Avatar picture={picture} text={text} size={24} />
  </div>
));

const getDemandRecruiterCell = ({
  demandRecruiterPictureUrl,
  demandRecruiterLastName,
  demandRecruiterFirstName,
}: DataType['demandRecruiter']): ReactNode => {
  const recruiterFullName =
    demandRecruiterLastName && demandRecruiterFirstName && `${demandRecruiterLastName} ${demandRecruiterFirstName}`;

  return (
    <div className={styles.recruiter}>
      {`${t('Demand:DemandWidgetList.recruiter')}`}
      {recruiterFullName && (
        <Tooltip placement="top" title={recruiterFullName}>
          <TooltipAvatar picture={demandRecruiterPictureUrl} text={recruiterFullName} />
        </Tooltip>
      )}
    </div>
  );
};

export default getDemandRecruiterCell;
